module.exports = __webpack_public_path__ + "static/media/swonkieBlack.b45dc4bd.svg";